import { graphql } from 'react-relay';

export const getDrawingSetVersionQuery = graphql`
    query getDrawingSetVersionQuery($id: ID!) {
        drawingSetVersion(id: $id) {
            ...drawingSetVersionFragment
        }
    }
`;
